import { defineMessages } from 'react-intl';

export const i18n: {
	opportunityStatusFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	opportunityStatusFilterLabel: {
		id: 'search-page.salesforce.filter.dealStatus',
		defaultMessage: 'Deal status',
		description: 'Label for filtering by Salesforce deal open/closed status',
	},
});
